/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'login';
const componentName = 'admin-user-setup';
const prefix = `${moduleName}.${componentName}`;

export const passwordFieldPlaceholder = `${prefix}.passwordFieldPlaceholder`;
export const deploymentPasswordFieldPlaceholder = `${prefix}.deploymentPasswordFieldPlaceholder`;
export const confirmPasswordFieldPlaceholder = `${prefix}.confirmPasswordFieldPlaceholder`;
export const emailFieldPlaceholder = `${prefix}.emailFieldPlaceholder`;
export const createAccountButtonLabel = `${prefix}.createAccountButtonLabel`;
export const samePasswordUsernameErrorMessage = `${prefix}.samePasswordUsernameErrorMessage`;

export const ENGLISH = {
    [passwordFieldPlaceholder]: 'Password',
    [deploymentPasswordFieldPlaceholder]: 'Deployment Password',
    [confirmPasswordFieldPlaceholder]: 'Confirm Password',
    [emailFieldPlaceholder]: 'Email Address (Optional)',
    [createAccountButtonLabel]: 'Create Account',
    [samePasswordUsernameErrorMessage]: 'Password should not be the same as username',
};
